<template>
  <div class="unitindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>员工福利信息列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/empwelfare/create')"
          >添加</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <!-- 时间选择 -->
        <el-col :span="5">
          <el-date-picker
            value-format="yyyy-MM"
            format="yyyy-MM"
            v-model="pickerDate"
            type="month"
            :editable="false"
            placeholder="请选择查询月份"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="17">&nbsp;</el-col>
        <!-- 搜索 -->
        <el-col :span="2">
          <el-button type="success" @click="clickSave">保存</el-button>
          <!-- <div style="color: red; font-size: 12px; margin-top: 4px">
            注：数据每次编辑完需要保存
          </div> -->
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="welfareList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { pageList, updateWelfare, deleteById } from '@/api/welfare'
import TzTable from '@/components/tz-table/Index.vue'
export default {
  components: {
    TzTable
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      editState: false,
      editWelfare: {},
      welfareList: [],
      pickerDate: '', //日期 时间戳
      columns: [
        {
          field: 'date',
          title: '月份'
        },
        {
          title: '高温补贴',
          type: 'isEdit',
          payload: {
            field: 'highTemperaturePay'
          }
        },
        {
          title: '过节费',
          type: 'isEdit',
          payload: {
            field: 'festivitiesPay'
          }
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    //选择日期事件
    handleDateChange(dialogPickerDate) {
      if (dialogPickerDate == null) {
        this.pickerDate = ''
      }
      this.page = 1
      this.getWelfareList()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getWelfareList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getWelfareList()
    },
    // 列表
    getWelfareList() {
      let welparams = {
        date: this.pickerDate,
        pageSize: this.size,
        pageNum: this.page
      }
      pageList(welparams).then((res) => {
        console.log(res.data, '列表')
        if (res.code == 200) {
          let infosArr = res.data.records
          this.total = res.data.total
          this.welfareList = infosArr
        }
      })
    },
    // 一键保存
    clickSave() {
      console.log(this.welfareList, '---保存---')
      this.$loading({
        text: '信息更新中'
      })
      updateWelfare(this.welfareList).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getWelfareList()
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      console.log('删除', row)

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteById(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getWelfareList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    userSearch() {
      this.page = 1
      this.getWelfareList()
    }
  },
  mounted() {
    this.getWelfareList()
  }
}
</script>

<style></style>
